import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Panel, Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Buildings, FloppyDisk } from "@phosphor-icons/react";
import { toast } from "sonner";

const FIELDS = [["legal_name", "Company Legal Name", "Asterism Services LLC"], ["ein", "EIN (Federal Tax ID)", "12-3456789"], ["phone", "Phone", "+1 (555) 000-0000"],
  ["email", "Billing Email", "billing@asterismservices.com"], ["website", "Website", "asterismservices.com"], ["address", "Full Address", "Street, City, State ZIP"]];

export function CompanyProfileCard() {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/company").then(({ data }) => setF(data)).catch(() => setF({})); }, []);
  const save = async () => {
    setSaving(true);
    try { await api.put("/settings/company", f); toast.success("Company profile saved. New invoices will use it."); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setSaving(false); }
  };
  if (!f) return null;
  return (
    <Panel className="p-6" data-testid="company-profile-card">
      <h3 className="font-heading font-bold text-slate-900 mb-1 flex items-center gap-2"><Buildings size={18} weight="duotone" className="text-blue-600" />Company Profile</h3>
      <p className="text-xs text-slate-500 mb-5">Printed on the header of every invoice next to your logo.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, l, ph]) => (
          <div key={k} className={k === "address" ? "sm:col-span-2" : ""}>
            <Field label={l}><Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph} className={`bg-white border-slate-300 ${k === "ein" ? "font-mono" : ""}`} data-testid={`company-${k}`} /></Field>
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-5"><Button onClick={save} disabled={saving} className="bg-blue-600 text-white hover:bg-blue-700 font-semibold" data-testid="company-save-btn"><FloppyDisk size={16} className="mr-1.5" />{saving ? "Saving…" : "Save Company Profile"}</Button></div>
    </Panel>
  );
}
